import script from "./OfficeExpensesDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OfficeExpensesDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OfficeExpensesDashboard.vue?vue&type=style&index=0&id=11116646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11116646"]])

export default __exports__